import { Company } from '@aibees/elephant/feature/search-table-company';

export function showKeywordsCondition(data?: Company) {
  return (
    data?.keywords?.length ||
    (data?.keywords?.length &&
      (data?.summary?.description || data?.summary?.seo)) ||
    (!data?.keywords?.length &&
      !data?.summary?.description &&
      !data?.summary?.seo)
  );
}

export function getCompanyInfoSectionVisibility(data?: Company) {
  const hasOverview = !!data?.summary?.description;
  const hasSeo = !!data?.summary?.seo;
  const hasProducts = !!data?.keywords && data.keywords.length > 0;

  const hasAnyData = hasOverview || hasSeo || hasProducts;

  return {
    showOverview: hasAnyData ? hasOverview : true,
    showSeo: hasAnyData ? hasSeo : true,
    showProducts: hasAnyData ? hasProducts : true,
  };
}
